import { render, staticRenderFns } from "./Vswitch.vue?vue&type=template&id=6881347c&"
import script from "./Vswitch.vue?vue&type=script&lang=js&"
export * from "./Vswitch.vue?vue&type=script&lang=js&"
import style0 from "./Vswitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports